define('actions/resource-buncees',[
    "jquery",
    "underscore",
    "backbone",
    "dispatcher/AppDispatcher",
    "constants/actiontypes",
    "shared/client",
    "shared/crm"
], 
function ($, _, Backbone, AppDispatcher, Constants, Client, CRM) {
    return Backbone.Model.extend({
        init: function(params) {
        },
        addResourceBuncees: function (params) {
            AppDispatcher.dispatch({
                actionType: Constants.ADD_RESOURCE_BUNCEES,
                data: params
            });
        },
        pull: function (options, onComplete) {
            var resourceBuncees = [];
            var self = this;

            window.api.request("organizer/resources", options).each(function iterator(index, item) {
                resourceBuncees.push({
                    title: item.data.title,
                    guid: item.data.guid,
                    owner_first_name: item.data.owner_first_name,
                    owner_last_name: item.data.owner_last_name,
                    created_at: new Date(item.data.created_at),
                    type: item.data.entity_type,
                    links: item.links
                });
            }, function () {
                self.addResourceBuncees(resourceBuncees);
                if (typeof onComplete === "function") {
                    onComplete();
                }
            });
        },
        duplicate: function(item, onComplete, onFail) {
            var self = this;
            var requestBody = {};
            requestBody.client = window.appData.client.resource_client_name;
            requestBody.guid = item.guid;
            window.api.request("buncees", item.guid, "duplicate").create(requestBody)
            .done(function (response) {
                if (typeof onComplete === "function") {
                    onComplete("buncee", response.links);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                if (typeof onFail === "function") {
                    onFail();
                }

                if (jqXHR.status == 403) {
                    window.toast('This Buncee is not copyable.');
                }
            });
        }
    });
});
